import React from 'react';

const ProvincesRanking = ({ data = [] }) => {
  const maxVentas = data.length > 0 ? Math.max(...data.map(p => p.cantidad)) : 1;

  return (
    <div className="statistics-chart" style={{marginTop:20}}>
      <h3 className="statistics-title">Ventas por Provincia</h3>
      <div className="provinces-list" style={{ marginTop: '15px' }}>
        {data.map((item, index) => (
          <div key={index} style={{ marginBottom: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '4px' }}>
              <span style={{ fontWeight: '600', color: '#475569' }}>{item.provincia}</span>
              <span style={{ color: '#8b5cf6', fontWeight: 'bold' }}>{item.cantidad}</span>
            </div>
            <div style={{ 
              width: '100%', 
              height: '8px', 
              background: '#f1f5f9', 
              borderRadius: '10px',
              overflow: 'hidden' 
            }}>
              <div style={{ 
                width: `${(item.cantidad / maxVentas) * 100}%`, 
                height: '100%', 
                background: 'linear-gradient(90deg, #a855f7, #8b5cf6)',
                borderRadius: '10px',
                transition: 'width 1s ease-in-out'
              }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProvincesRanking;